export default __webpack_public_path__ + "static/1992-d969fb69947f42395db89773d857afca.png";